import {Component} from '@angular/core';
import {BanIcon, CheckIcon, LucideAngularModule} from 'lucide-angular';

@Component({
  selector: 'app-activity-publish-rules',
  imports: [
    LucideAngularModule
  ],
  templateUrl: './activity-publish-rules.component.html'
})
export class ActivityPublishRulesComponent {

  public readonly icons = {
    checkmark: CheckIcon,
    ban: BanIcon
  };
}
